import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { api, TOKEN_KEY } from "@/lib/api";
import { PageLoader } from "@/components/common";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);

  const refresh = useCallback(async () => {
    if (!localStorage.getItem(TOKEN_KEY)) return setUser(false);
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
    } catch {
      localStorage.removeItem(TOKEN_KEY);
      setUser(false);
    }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  const login = async (identifier, password, portal) => {
    const { data } = await api.post("/auth/login", { identifier, password, portal });
    localStorage.setItem(TOKEN_KEY, data.token);
    setUser(data.user);
    return data.user;
  };

  const logout = () => {
    localStorage.removeItem(TOKEN_KEY);
    setUser(false);
  };

  return <AuthCtx.Provider value={{ user, setUser, login, logout, refresh }}>{children}</AuthCtx.Provider>;
}

export const useAuth = () => useContext(AuthCtx);

export const homeFor = (u) => (u?.role === "admin" ? "/admin" : u?.role === "tutor" ? "/tutor" : "/student");

export function Protected({ role, children }) {
  const { user } = useAuth();
  const loc = useLocation();
  if (user === null) return <PageLoader />;
  if (!user) return <Navigate to={role === "admin" ? "/admin/login" : `/login/${role}`} replace />;
  if (user.role !== role) return <Navigate to={homeFor(user)} replace />;
  if (user.must_change_password && loc.pathname !== "/admin/change-password")
    return <Navigate to="/admin/change-password" replace />;
  return children;
}
